import { ChertoExperiments } from 'constants/experiments'
import useExperiment from 'hooks/Experiments/useExperiment'
import { useCroMobileCompactSearchTileAudience } from 'hooks/Search/useCroMobileCompactSearchTileExperiment'
import { useAppSelector } from 'hooks/reduxHooks'
import { isGhaPriceDisplay } from 'selectors/routerSelectors'
import { isGoogleHotelAdsBot } from 'selectors/accountSelectors'
import { isEligibleOfferTilePriceBlock, type OfferTilePriceBlockEligibility, type OfferTilePriceBlockVariation } from 'lib/offer/offerTilePriceBlockExperiment'

export default function useOfferTilePriceBlockExperiment(offer: OfferTilePriceBlockEligibility | undefined, hotelOnlyPrice?: boolean, canShowPrice = true): OfferTilePriceBlockVariation | undefined {
  const isGhaPricing = useAppSelector(isGhaPriceDisplay)
  const isGoogleHotelAds = useAppSelector(isGoogleHotelAdsBot)
  const isCompactSearchFunnel = useCroMobileCompactSearchTileAudience()
  // Metasearch owns a different leading price; do not change that pricing contract.
  const eligible = isEligibleOfferTilePriceBlock(offer, hotelOnlyPrice) && canShowPrice && !isGhaPricing && !isGoogleHotelAds && !isCompactSearchFunnel
  const { variation } = useExperiment(ChertoExperiments.croOfferTilePriceBlock, { canActivate: eligible })

  return eligible && (variation === 'variant-a' || variation === 'variant-b') ? variation : undefined
}
